import { FC, ComponentProps } from "react";
import { Input, Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { PassengerEditIcon } from "src/assets/Icons";

type GuestTextFieldProps = ComponentProps<typeof Input>;

const GuestTextField: FC<GuestTextFieldProps> = ({ placeholder, className, ...props }) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  if (isLargeScreen) {
    return <Input placeholder={placeholder} className={className ?? "p-2!"} {...props} />;
  }

  return (
    <Input
      placeholder={placeholder}
      variant="borderless"
      prefix={<PassengerEditIcon className="h-4! w-4! me-2 text-font-subtle" />}
      {...props}
      className="text-font-default! border-border-default! border-b! font-semibold shadow-none! rounded-none! pt-2! pb-2! px-1! w-full"
    />
  );
};

export default GuestTextField;
